import { render, staticRenderFns } from "./GNoDataSpan.vue?vue&type=template&id=d2dbec98&scoped=true&"
import script from "./GNoDataSpan.vue?vue&type=script&lang=ts&"
export * from "./GNoDataSpan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2dbec98",
  null
  
)

export default component.exports